/* eslint-disable @typescript-eslint/no-explicit-any */

import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { typeCheck } from "@/lib/type-check";
import { cn } from "@/lib/utils";
// import { useDocument } from "../hook/useDocument";
// import { useState } from "react";

export const AuditListingItem = ({
  keyValue,
  data,
  // parentKey,
  isFirstRow,
}: // feedback,
any) => {
  const types: any = typeCheck(data);

  const displayObjectValue = (dataProps: any) => {
    try {
      const tempData: any = JSON.stringify(dataProps, null, 2);
      return tempData
        .replaceAll("{", "")
        .replaceAll("}", "")
        .replaceAll(`""`, "");
    } catch (error) {
      console.log(error);
      return dataProps;
    }
  };

  return (
    <div
      className={cn(
        "relative flex w-full pr-2 text-[14px] items-center border border-slate-200  text-slate-400 border-l-0 border-r-0",
        isFirstRow ? "" : "border-t-0",
        "clear-both"
      )}
    >
      <div
        className={cn(
          "py-3 pl-0 pr-4 text-left sm:break-normal sm:break-words break-anywhere ",
          "w-[150px]"
        )}
      >
        {keyValue}
      </div>
      <div
        className={cn(
          "relative flex items-center flex-grow pl-3 text-slate-600 text-left sm:break-normal sm:break-words break-anywhere ",
          "w-[calc(100%_-_150px)]"
        )}
      >
        <span className="absolute left-0">:</span>
        <ConditionRenderer condition={typeof data === "string"}>
          <>{data}</>
        </ConditionRenderer>
        <ConditionRenderer condition={types === "Object"}>
          <pre>{displayObjectValue(data)}</pre>
        </ConditionRenderer>
        <ConditionRenderer condition={types === "Array"}>
          {data?.[0]?.text}
        </ConditionRenderer>
      </div>
    </div>
  );
};
